import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonItalic} from 'mui-tiptap';

const StyledEditorMenuButtonItalic = styled(MenuButtonItalic)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonItalic.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonItalic;
